<template>
  <div>
    <div class="columns is-multiline">
      <div class="column is-full" style="margin-top:-1.7rem;margin-bottom:-1rem">
        <div style="font-size:1.4rem;"><strong>파트너 등급 등록/수정</strong></div>
        <div>파트너 등급을 새로 만들고 등급을 나누는 기준을 설정, 수정합니다.</div>
      </div>
      <div class="column is-full">
        <!-- 저장하기 -->
        <div class="btn-group-justify-end">
          <button class="button is-grey cancel" @click="cancel">취소</button>
          <button class="button is-primary" @click="saveData">저장하기</button>
        </div>
        <div class="box">
          <admin-box-item title="기본 정보 설정">
            <div class="columns is-multiline">
              <div class="column is-full">
                <admin-form-item label="파트너등급 순서*" desc="높은 숫자가 더 높은 등급입니다.">
                  <lp-adm-drop-input
                    @onSelect="res => value.order = res.value"
                    :selectVal="value.order"
                    :data.sync="userGradeOrderArr"
                    width="80px"
                    listAlign="center"></lp-adm-drop-input>
                </admin-form-item>
              </div>

              <div class="column is-4">
                <admin-form-item label="파트너등급 이름*">
                  <input class="input"
                         type="text"
                         :value="value.name"
                         @input="e => value.name = e.target.value">

                </admin-form-item>
              </div>

              <div class="column is-full">
                <admin-form-item label="파트너등급 라벨 표시 방법">
                  <lp-radio-label-represent @onSelect="res => setValue(res, 'label_type')"
                                            :val.sync="value.label_type"
                                            :data="labelType"></lp-radio-label-represent>
                </admin-form-item>
              </div>

              <div class="column is-full">
                <admin-form-item label="파트너등급 라벨 표시 스타일">
                  <div class="columns is-multiline">
                    <div class="column is-3">
                      <admin-form-item>
                        <lp-color-picker name="테두리 컬러"
                                         :val.sync="value.color.border"></lp-color-picker>
                      </admin-form-item>
                    </div>
                    <div class="column is-3">
                      <admin-form-item>
                        <lp-color-picker name="텍스트 컬러"
                                         :val.sync="value.color.color"></lp-color-picker>
                      </admin-form-item>
                    </div>
                    <div class="column is-3">
                      <admin-form-item>
                        <span v-if="value.label_type===0"  class="lp-grade-label lp-label-represent-border-text" :style="labelStyle">일반파트너</span>
                        <span v-else-if="value.label_type===1"  class="lp-grade-label lp-label-represent-text" :style="labelStyle">일반파트너</span>
                        <span v-else-if="value.label_type===2"  class="lp-grade-label lp-label-represent-icon-text" :style="labelStyle">
                          <i class="material-icons" style="vertical-align: middle">person_outline</i>
                          일반파트너
                        </span>
                        <span v-else-if="value.label_type===3"  class="lp-grade-label lp-label-represent-circle-label-text" :style="labelStyle">일반파트너</span>
                        <span v-else-if="value.label_type===4"  class="lp-grade-label lp-label-represent-square-label-text" :style="labelStyle">일반파트너</span>
                      </admin-form-item>
                    </div>
                  </div>
                  <div class="flex">
                    <div style="margin-right: 8px">

                    </div>
                    <div>

                    </div>
                    <div style="width: 100%; position: relative; margin-left:30px;">

                    </div>
                  </div>
                </admin-form-item>
              </div>

              <div class="column is-full">
                <admin-form-item label="승인심사 종류 선택">
                  <lp-radio @onSelect="res => setValue(res, 'approval_type')"
                            value_name="value"
                            label_name="label"
                            :val.sync="value.approval_type"
                            :data="confirmTypeArr"
                            :block="true"></lp-radio>
                </admin-form-item>
              </div>

              <div class="column is-full">
                <admin-form-item label="승인방법">
                  <lp-radio @onSelect="res => setValue(res, 'is_auto_approval')"
                            value_name="value"
                            label_name="label"
                            :val.sync="value.is_auto_approval"
                            :data="confirmWayArr"
                            :block="true"></lp-radio>
                </admin-form-item>
              </div>
            </div>
          </admin-box-item>
        </div>
      </div>

      <div class="column is-full" v-if="value.approval_type===0 || value.approval_type===2">
        <div class="box">
          <admin-box-item title="컨텐츠 심사 후 승인 설정">
            <div class="columns is-multiline">
              <div class="column is-full">
                <div class="lp-subtitle-block">운전면허증이나 사업자등록증 등 등급 승인에
                  필요한 컨텐츠를 입력받고 승인해 줄 때 필요한 사항들을 설정합니다.</div>
              </div>
              <div class="column is-full">
                <admin-form-item label="심사할 컨텐츠 지정">
                  <button class="button"
                          style="color:#989898;
                          background-color: #eee"
                          @click="openSetting">설정하기</button>
                </admin-form-item>
              </div>
              <div class="column is-full flex">
                <label class="label">폼 템플릿명:</label>
                <div style="font-size: 0.9rem" v-if="value.content_form_id">{{ selected_form_name }}</div>
              </div>
              <div class="column is-full flex">
                <label class="label">심사할 컨텐츠:</label>
                <div style="font-size: 0.9rem">{{ selectedContent }}</div>
              </div>
            </div>
          </admin-box-item>
        </div>
      </div>

      <div class="column is-full" v-if="value.approval_type===1 || value.approval_type===2">
        <div class="box">
          <admin-box-item title="활동지수 충족 시 승인 설정">
            <div class="columns is-multiline">
              <div class="column is-full">
                <div class="lp-subtitle-block">
                  운전면허증이나 사업자등록증 등 등급 승인에 필요한
                  컨텐츠를 입력받고 승인해 줄 때 필요한 사항들을 설정합니다.
                </div>
              </div>

              <div class="column is-full">
                <admin-form-item label="서비스 참여 기준">
                  <div class="columns is-multiline" style="margin-top: 0">
                    <div class="column is-3 flex">
                      <div class="lp-active-title">방문</div>
                      <lp-adm-drop-input @onSelect="res => value.service_active.visit = res.value"
                                         :selectVal="value.service_active.visit"
                                         :data.sync="countArr"
                                         width="80px"
                                         listAlign="center"></lp-adm-drop-input>
                      <div class="lp-active-count">회</div>
                    </div>

                    <div class="column is-3 flex">
                      <div class="lp-active-title">상품 찜</div>
                      <lp-adm-drop-input @onSelect="res => value.service_active.product_like = res.value"
                                         :selectVal="value.service_active.product_like"
                                         :data.sync="countArr"
                                         width="80px"
                                         listAlign="center"></lp-adm-drop-input>
                      <div class="lp-active-count">회</div>
                    </div>

                    <div class="column is-3 flex">
                      <div class="lp-active-title">상품 공유</div>
                      <lp-adm-drop-input @onSelect="res => value.service_active.share = res.value"
                                         :selectVal="value.service_active.share"
                                         :data.sync="countArr"
                                         width="80px"
                                         listAlign="center"></lp-adm-drop-input>
                      <div class="lp-active-count">회</div>
                    </div>
                  </div>
                </admin-form-item>
              </div>

              <div class="column is-full">
                <admin-form-item label="게시판 참여 기준">
                  <div class="columns is-multiline" style="margin-top: 0">
                    <div class="column is-3 flex">
                      <div class="lp-active-title">글쓰기</div>
                      <lp-adm-drop-input @onSelect="res => value.board_active.like = res.value"
                                         :selectVal="value.board_active.like"
                                         :data.sync="countArr"
                                         width="80px"
                                         listAlign="center"></lp-adm-drop-input>
                      <div class="lp-active-count">회</div>
                    </div>

                    <div class="column is-3 flex">
                      <div class="lp-active-title">답글</div>
                      <lp-adm-drop-input @onSelect="res => value.board_active.reply = res.value"
                                         :selectVal="value.board_active.reply"
                                         :data.sync="countArr"
                                         width="80px"
                                         listAlign="center"></lp-adm-drop-input>
                      <div class="lp-active-count">회</div>
                    </div>

                    <div class="column is-3 flex">
                      <div class="lp-active-title">좋아요</div>
                      <lp-adm-drop-input @onSelect="res => value.board_active.share = res.value"
                                         :selectVal="value.board_active.share"
                                         :data.sync="countArr"
                                         width="80px"
                                         listAlign="center"></lp-adm-drop-input>
                      <div class="lp-active-count">회</div>
                    </div>

                    <div class="column is-3 flex">
                      <div class="lp-active-title">공유</div>
                      <lp-adm-drop-input @onSelect="res => value.board_active.write = res.value"
                                         :selectVal="value.board_active.write"
                                         :data.sync="countArr"
                                         width="80px"
                                         listAlign="center"></lp-adm-drop-input>
                      <div class="lp-active-count">회</div>
                    </div>
                  </div>
                </admin-form-item>
              </div>

              <div class="column is-full">
                <admin-form-item label="구매전환 기준">
                  <div class="columns is-multiline" style="margin-top: 0">
                    <div class="column is-3 flex">
                      <div class="lp-active-title">전화연결</div>
                      <lp-adm-drop-input @onSelect="res => value.order_active.call.call_count = res.value"
                                         :selectVal="value.order_active.call.call_count"
                                         :data.sync="countArr"
                                         width="80px"
                                         listAlign="center"></lp-adm-drop-input>
                      <div class="lp-active-count">회</div>
                    </div>
                  </div>
                </admin-form-item>
              </div>
            </div>
          </admin-box-item>
        </div>

        <!-- 저장하기 -->
        <div class="btn-group-justify-end">
          <button class="button is-grey cancel" @click="cancel">취소</button>
          <button class="button is-primary" @click="saveData">저장하기</button>
        </div>
      </div>
    </div>

    <modal name="formSetting" :adaptive="true" :width="900" height="auto" class="modal-style">
      <div class="lp-modal-wrapper">
        <partner-param-form page="grade" :grade_id="$route.query.id" @selectForm="selectForm" @closed="closeModal"></partner-param-form>
        <!--<modal-grade-content-setting :content_form="value.content_form"></modal-grade-content-setting>-->
      </div>
    </modal>
  </div>
</template>

<script>
  import LpAdmDropInput from "../../module/common/LpAdmDropInput";
  import LpRadio from "../../module/common/LpRadio";
  import LpColorPicker from "../../module/common/LpColorPicker";
  import LpRadioLabelRepresent from "../../module/custom/LpRadioLabelRepresent";
  import PartnerParamForm from "./PartnerParamForm";

  export default {
    layout: 'Main',
    components: {
      PartnerParamForm,
      LpRadioLabelRepresent,
      LpColorPicker,
      LpRadio,
      LpAdmDropInput
    },
    data() {
      return {
        value: {
          content_form_id: '',
          order:'',
          name:'',
          service_active: {
            visit: 0,
            product_like: 0,
            product_share: 0,
          },
          board_active: {
            like: 0,
            reply: 0,
            share: 0,
            write: 0
          },
          order_active: {
            call: {
              call_count: 0
            }
          },
          label_type: 1,
          approval_type: 1,
          is_auto_approval: false,
          color: {
            color: {
              r:255,
              g:87,
              b:43,
              a:1
            },
            border: {
              r:255,
              g:87,
              b:43,
              a:1
            }
          }
        },
        // 파트너등급 순서
        userGradeOrderArr: [
          {label: '1', value: 1 },
          {label: '2', value: 2 },
          {label: '3', value: 3 },
          {label: '4', value: 4 },
          {label: '5', value: 5 },
          {label: '6', value: 6 },
          {label: '7', value: 7 },
          {label: '8', value: 8 },
        ],
        // 파트너등급 라벨 표시 방법 리스트
        labelType: [
          {label: '테두리+텍스트형', value: 0},
          {label: '텍스트형', value: 1},
          {label: '아이콘+텍스트형', value: 2},
          {label: '둥근라벨+텍스트형', value: 3},
          {label: '사각라벨+텍스트형', value: 4},
        ],
        // 승인심사 종류 선택
        confirmTypeArr: [
          {label: '컨텐츠 심사 후 승인', value: 0, detail: '사용자가 입력 한 심사컨텐츠를 확인 및 검증 후 승인처리 합니다. e.g. 운전면허증, 사업자등록증 등'},
          {label: '활동지수 충족 시 승인', value: 1, detail: '사용자가 활동지수를 충족할 시 신규승인요청이 되고 직접 확인 후 승인처리 합니다.'},
          {label: '둘 다 충족 시 승인', value: 2, detail: '사용자가 컨텐츠 입력과 활동지수 둘 다 충족해야 신규승인요청이 되고 이를 확인 후 승인처리 합니다.'}
        ],
        // 승인 방법
        confirmWayArr: [
          {label: '활동지수 충족 시 컨텐츠 심사 후 승인', value: false, detail: '활동지수가 충족된 사용자의 심사컨텐츠를 확인 및 검증 후 승인처리 합니다. e.g. 운전면허증, 사업자등록증 등'},
          {label: '컨텐츠 입력 및 활동지수 충족 시 자동으로 승인', value: true, detail: '사용자가 컨텐츠를 입력한 상태이고 활동지수를 충족할 경우 컨텐츠 검수 없이 자동으로 승인처리 하여 등급변경이 되게 합니다. e.g. 방문목적 응답 등'},
        ],
        countArr: [
          {label: '0', value: 0},
          {label: '1', value: 1},
          {label: '2', value: 2},
          {label: '3', value: 3},
          {label: '4', value: 4},
          {label: '5', value: 5},
          {label: '6', value: 6},
          {label: '7', value: 7},
          {label: '8', value: 8},
          {label: '9', value: 9},
          {label: '10', value: 10},
        ],
        partnerParamForm: [],
        selected_form_name: ''
      }
    },
    computed: {
      labelStyle(){
        return 'borderColor: rgba('
          + this.value.color.border.r + ','
          + this.value.color.border.g + ','
          + this.value.color.border.b + ','
          + this.value.color.border.a + ');'
          + 'color: rgba('
          + this.value.color.color.r + ','
          + this.value.color.color.g + ','
          + this.value.color.color.b + ','
          + this.value.color.color.a + ');';
      },
      // 심사할 컨텐츠
      selectedContent(){
        if (this.partnerParamForm){
          let text_arr = [];

          this.partnerParamForm.forEach(item=>{
            if(item.enable===true) text_arr.push(item.name);
          })
          let result = text_arr.join(', ')
          return result;
        }
      }
    },
    created() {
      this.getData();

      this.$axios.get('public/service/partner_grade').then(res => {
        if(res.status===200) {
          let grade_list = res.data;
          for(let i=0; i<grade_list.length; i++) {
            for(let j=0; j<this.userGradeOrderArr.length; j++) {
              if(grade_list[i].order===this.userGradeOrderArr[j].value) {
                this.userGradeOrderArr.splice(j, 1);
              }
            }
          }
        }
      })
    },
    watch: {
      modalStatus(n) {
        if(n==='close'){
          this.getData();
        }
      }
    },
    methods: {
      selectForm(value) {
        this.value.content_form_id = value;
        this.$modal.hide('formSetting');
        this.getFormData();

      },
      getFormData() {
        this.$axios.get('admin/partner/formdata/' + this.value.content_form_id).then(res=>{
          if(res.status===200) {
            this.partnerParamForm = res.data.data;
            this.selected_form_name = res.data.type;
          }
        })
      },
      closeModal() {
        this.$modal.hide('formSetting');
      },
      // 설정하기
      openSetting() {
        this.$modal.show('formSetting');
        // let value = {
        //   id: this.$route.query.id
        // }
        // this.$store.commit('openModal', {type: 'modal-grade-content-setting', value: value})
      },
      // 선택한 값 저장
      setValue(res, type){
        this.value[type] = res;
      },
      saveData() {
        let err = '';
        if(!this.value.order) err = '등급순서를 선택하세요.';
        else if(!this.value.name) err = '파트너등급 이름을 입력하세요.';

        if(err) {
          this.toast(err);
          return;
        }

        if(this.$route.query.id){
          this.$axios.patch(this.getUrl('member/partner-grade/' + this.$route.query.id), this.value).then(res=>{
            if(res.status===200) {
              this.toast('저장되었습니다.');
              this.$router.replace(this.getPath('partner/grade'));
            }
          })
        }
        else {
          this.$axios.post(this.getUrl('member/partner-grade'), this.value).then(res=>{
            if(res.status===200) {
              this.saveServiceGuide('partner_grade');
              this.toast('저장되었습니다.');
              this.$router.replace(this.getPath('partner/grade'));
            }
          })
        }
      },
      cancel() {
        this.$router.back();
      },
      getData() {
        if(this.$route.query.id){
          this.$axios.get(this.getUrl('member/partner-grade/' + this.$route.query.id)).then(res=>{
            if(res.data.color.color === '') {
              res.data.color.color = {
                r: 255,
                g: 87,
                b: 43,
                a: 1
              };
            }
            if(res.data.color.border === '') {
              res.data.color.border = {
                r:255,
                g:87,
                b:43,
                a:1
              };
            }
            this.value = res.data;

            if(this.value.content_form_id) {
              this.getFormData();
            }
          })
        }
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  @import '~assets/css/lp_variable'
  .lp-active-title
    margin-top 4px
    margin-right 15px

  .lp-active-count
    margin-top 4px
    margin-left 15px

  .lp-grade-label
    padding 2px 8px
    font-size 0.8rem
    line-height 56px

  .lp-label-represent-border-text
    border 1px solid $primary
    padding 2px 8px
    border-radius 16px
    color $primary

  .lp-label-represent-text
    color $primary

  .lp-label-represent-icon-text
    color $primary
  .lp-label-represent-circle-label-text
    background-color $primary
    border-radius 6px
    color white
  .lp-label-represent-square-label-text
    background-color $primary
    color white

</style>
